<template>
<div class="feedback-btn" @click="() => (popupVisible = !popupVisible)">
    <moo-popover placement="bottom" popper-class="feed_poper_container" v-bind:value="popupVisible" @after-leave="onPopoverHidden">
      <!-- btton -->
      <div slot="reference">
        <!-- <svg-icon class-name="xxxxxx" icon-class="rateIcon"></svg-icon> -->
        <moo-tooltip slot="reference" effect="light" :content="$t('反馈#!!!#src/pages/H5/Cloud/components/feedback.vue_2')" placement="bottom" popper-class="share-tooltip-class" :visible-arrow="false" :manual="true" :value="showFeedbackTip">
          <span class="rate_button" @click="showFeedbackTip = false" @mouseenter="feedbackMouseEnter" @mouseleave="showFeedbackTip = false">{{$t("反馈#!!!#src/pages/H5/Cloud/components/feedback.vue_1")}}</span>
        </moo-tooltip>
      </div>
      <!-- popup -->
      <div v-show="popupContainerType === 'popup'" class="popup_container">
        <div class="popover_container_item" @click="rateItemButtonAction">
          <svg-icon icon-class="greyStar"></svg-icon>
          <span>{{$t("满意度评分#!!!#src/pages/H5/Cloud/components/feedback.vue_1")}}</span>
        </div>
        <div style="height: 4px;"></div>
        <div class="popover_container_item" @click="handleFeedbackClick">
          <svg-icon icon-class="greyTips"></svg-icon>
          <span>{{$t("问题反馈#!!!#src/pages/H5/Cloud/components/feedback.vue_1")}}</span>
        </div>
      </div>
      <!-- feedback popup -->
      <div v-show="popupContainerType === 'feedback'" class="feedback_popup_container">
        <div class="feed_title_container">
          <div class="feed_title">{{$t("给管家文档打个分吧～#!!!#src/pages/H5/Cloud/components/feedback.vue_1")}}</div>
          <div class="feed_close_btn" @click="() => (popupVisible = false)">
            <svg-icon icon-class="close"></svg-icon>
          </div>
        </div>
        <div class="feed_content">
          <div @mouseenter="() => (hoverFeedItemIndex = index)" @mouseleave="() => (hoverFeedItemIndex = -1)" class="feed_item" v-for="(item, index) in feedItems" :key="index" @click="feedContentItemAction(item, index)">
            <div class="feed_item_score" :class="[
                hoverFeedItemIndex === index ? 'feed_item_score_hover' : '',
              ]">
              {{ item.score }}
            </div>
            <div class="feed_item_desc" :class="[
                hoverFeedItemIndex === index ? 'feed_item_desc_hover' : '',
              ]" v-html="item.desc"></div>
          </div>
        </div>
      </div>
    </moo-popover>
  </div>
</template>

<script>
import { intl } from 'tci18n-vue2'
import { apiScoreRate } from "@/api/h5/score_rate.js";
export default {
  name: "feedback",
  data() {
    return {
      popupVisible: false,
      popupContainerType: "popup", // as 'popup' | 'feedback',
      hoverFeedItemIndex: -1,
      feedbackUrl: "https://task.17usoft.com/share/shrnJEQZhBc54LHkb2Bqc",
      feedItems: [
      { score: intl.$t("1分#!!!#src/pages/H5/Cloud/components/feedback.vue_1"), desc: intl.$t("不好用<br>完全不行#!!!#src/pages/H5/Cloud/components/feedback.vue_1") },
      { score: intl.$t("2分#!!!#src/pages/H5/Cloud/components/feedback.vue_1"), desc: intl.$t("凑合能用<br>还行#!!!#src/pages/H5/Cloud/components/feedback.vue_1") },
      { score: intl.$t("3分#!!!#src/pages/H5/Cloud/components/feedback.vue_1"), desc: intl.$t("符合预期<br>还不错#!!!#src/pages/H5/Cloud/components/feedback.vue_1") },
      { score: intl.$t("4分#!!!#src/pages/H5/Cloud/components/feedback.vue_1"), desc: intl.$t("超过预期<br>非常好#!!!#src/pages/H5/Cloud/components/feedback.vue_1") },
      { score: intl.$t("5分#!!!#src/pages/H5/Cloud/components/feedback.vue_1"), desc: intl.$t("天大惊喜<br>太棒了#!!!#src/pages/H5/Cloud/components/feedback.vue_1") }],

      showFeedbackTip: false
    };
  },
  methods: {
    feedbackMouseEnter() {
      if (!this.popupVisible) {
        this.showFeedbackTip = true;
      }
    },
    rateItemButtonAction() {
      this.popupContainerType = "feedback";
      // poper 位置调整容器变后更不生效，需要手动调整
      this.$nextTick(() => {
        const container = document.querySelector(".feed_poper_container");
        container.style.left = "unset";
        container.style.right = "16px";
      });
    },
    handleFeedbackClick() {
      window.open(this.feedbackUrl, "_blank");
    },
    onPopoverHidden() {
      this.popupContainerType = "popup";
      this.popupVisible = false;
    },
    async feedContentItemAction(item, index) {
      const resp = await apiScoreRate(index + 1).catch((e) => {});
      this.popupVisible = false;
      if (resp?.code === 200) {
        this.$message.success(intl.$t("操作成功#!!!#src/pages/H5/Cloud/components/feedback.vue_1"));
      } else {
        this.$message.error(intl.$t("操作失败#!!!#src/pages/H5/Cloud/components/feedback.vue_1"));
      }
    }
  }
};
</script>

<style lang="scss" scoped>
.rate_button {
  font-size: 14px;
  color: #222329;
}

.xxxxxx {
  width: 32px;
  height: 17px;
  display: flex;
}

.feedback_popup_container {
  margin-right: 16px;
  width: 301px;
  background-image: linear-gradient(180deg, #ecefff 0%, #ffffff 100%);
  box-shadow: 0 10px 20px 0 #22232926;
  border-radius: 8px;
  padding: 16px 16px 24px 16px;
  .feed_title_container {
    display: flex;
    justify-content: space-between;
    .feed_title {
      font-weight: 500;
      font-size: 15px;
      color: #222329;
    }
    .feed_close_btn {
      width: 18px;
      height: 18px;
      border-radius: 4px;
      color: #979ba5;
      display: flex;
      justify-content: center;
      align-items: center;
      svg {
        font-size: 10px;
      }
      &:hover {
        background: #ffffff;
      }
    }
  }

  .feed_content {
    display: flex;
    justify-content: space-between;
    padding-top: 16px;
    .feed_item {
      width: 40px;
      height: 64px;
      display: flex;
      flex-direction: column;
      align-items: center;
      font-size: 10px;
      cursor: pointer;
      .feed_item_score {
        color: #5c70ff;
        font-weight: 500;
        width: 32px;
        height: 32px;
        border-radius: 18px;
        text-align: center;
        line-height: 32px;
        background-color: white;
        margin-bottom: 4px;
      }
      .feed_item_score_hover {
        color: #ffffff;
        background: #5c70ff;
      }
      .feed_item_desc {
        color: #7b7d82;
        text-align: center;
      }
      .feed_item_desc_hover {
        color: #222329;
      }
    }
  }
}

.popup_container {
  width: 146px;
  background: #ffffff;
  border: 1px solid #e6e8ec;
  box-shadow: 0 8px 12px 0 #1213171a;
  border-radius: 8px;
  padding: 4px !important;
  box-sizing: border-box;

  .popover_container_item {
    height: 32px;
    background: #ffffff;
    border-radius: 4px;
    display: flex;
    align-items: center;
    padding: 0 8px;
    box-sizing: border-box;
    color: #222329;
    &:hover {
      background: #f4f6f9;
    }
    svg {
      margin-right: 8px;
      font-size: 17px;
    }
  }
}

.feedback-btn {
  width: auto;
  min-width: 36px;
  height: 26px;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  margin-left: 12px;
  padding: 0 4px;
  font-family: "PingFang SC", sans-serif;
  font-weight: 400;
  font-size: 14px;

  &:hover {
    background: #f4f6f9;
    border-radius: 4px;
  }

  .feedback-icon {
    width: 16px;
    height: 16px;
  }
}
</style>

<style lang="scss">
.feed_poper_container {
  margin: 0px !important;
  padding: 0px !important;
  border: none !important;
  -webkit-box-shadow: none !important;
  -moz-box-shadow: none !important;
  box-shadow: none !important;
  margin-top: 10px !important;
}

.feedback-tooltip-class {
  top: 35px !important;
  border-radius: 8px !important;
  color: #767c85;
  font-size: 14px !important;
  font-weight: 400;
  padding: 8px !important;
  background-color: #fff !important;
  box-shadow: 0 8px 12px 0 #1213171a !important;
  border: none !important;
  height: 22px;
  line-height: 24px !important;
  margin-top: 13px !important;
  text-align: center !important;
}
</style>
